
var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Classes.PointFeature = new Class({
    Extends: OCS.Viewer.Classes.AbstractFeature,
    class_name: "PointFeature",
    geom_request: null,
    options: {
        properties: {
            name: '',

        },
    },
    get_name: function () {
        var feature_obj = this.get_ol_object();
        if(feature_obj) {
            return feature_obj.get('NAME');
        } else {
            return false;
        }

    }

});